import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  labelColor?: string;
}

export const Root = styled.div`
  z-index: 300;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
`

export const BoxContainer = styled.div`
  position: relative;
  width: 744px;
  height: 477.5px;
  padding: 0px 0px 44.5px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
`

export const TitleContainer = styled.div`
  padding: 22px 60px 17px 60px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  align-items: center;
  justify-content: space-between;
`

export const LeftSide = styled.div`
`
export const Title = styled.div`
  padding: 0px 0px 11px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SubtitleContainer = styled.div`
  display: flex;
`

export const Subtitle = styled.div`
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const Hour = styled.div`
  padding: 0px 0px 0px 12px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.MID_GRAY};
`

export const RightSide = styled.div`
  color: ${(props: IRootProps) => props.labelColor ? props.labelColor : "#f5bc00"};
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const Content = styled.div`
  width: 100%;
  padding: 28px 0px 0px 0px;
  height: 326px;
  overflow-y: auto;
`

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 60px;
  bottom: 48px;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`